var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMAhorro(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#2eccb6;}.cls-3{fill:#329be6;}.cls-4{fill:#0b5c96;}.cls-5{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_ahorro"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ahorros"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.18 52.48 19.48 52.48 19.18 52.17 19.18 52.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "47.84 52.48 47.84 51.16 46.52 52.48 47.84 52.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.67,11.82v1.51l1.39-1.39A7.58,7.58,0,0,0,19.67,11.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.77,17.85c-.58-.27-.91-.73-.82-1.15s.83-.86,1.83-.86V14c-2.29,0-3.37,1.18-3.6,2.29a2.53,2.53,0,0,0,0,.82l4.12,4.12a3.29,3.29,0,0,0,.15-1.13A2.61,2.61,0,0,0,52.77,17.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.22,26.18a26,26,0,0,1,7-8.38v-2L6.82,26.18h3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.39,28.61.28,32.72a.4.4,0,0,0,0,.56l4.11,4.11V28.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.29,46.57C13.8,45.11,11.43,43.72,9.93,41H8l8.72,8.72V46.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36,55a.4.4,0,0,1-.4-.4V51.32a28.93,28.93,0,0,1-3.09.16h-1v3.11a.4.4,0,0,1-.4.4H22L32.72,65.72a.4.4,0,0,0,.56,0L44,55H36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27,12.89a23.05,23.05,0,0,1,5.46-.67,28,28,0,0,1,15.17,4.35,5.2,5.2,0,0,1,.1-.78A5.31,5.31,0,0,1,48,15L33.28.28a.4.4,0,0,0-.56,0L23.07,9.93A8.93,8.93,0,0,1,27,12.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.72,32.72l-9.54-9.54A6,6,0,0,1,55,24.71a16.54,16.54,0,0,1,1.64,7.14,17.6,17.6,0,0,1-6.29,13.23v3.58L65.72,33.28A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.39,38.46v2.1a.4.4,0,0,0,.4.4H8L4.39,37.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.79,26.18a.39.39,0,0,0-.4.4v2l2.43-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.18,52.48v-.3l-2.5-2.5v4.9a.39.39,0,0,0,.4.4H22l-2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.67,11.82a7.58,7.58,0,0,1,1.39.12l2-2a9.28,9.28,0,0,0-3.4-.61h-2.1a.39.39,0,0,0-.4.4v6.11l2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.84,52.48H46.52L44,55h5.92a.4.4,0,0,0,.4-.4V48.66l-2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.18,16.32c.23-1.11,1.31-2.29,3.6-2.29v1.81c-1,0-1.72.34-1.83.86s.24.88.82,1.15a2.61,2.61,0,0,1,1.64,2.28,3.29,3.29,0,0,1-.15,1.13l1.92,1.92A6.06,6.06,0,0,0,56.9,20a5.1,5.1,0,0,0-.62-2.16V11.93a.4.4,0,0,0-.4-.4h-2.1c-3.28,0-5.09,1.72-5.79,3.46l2.15,2.15A2.53,2.53,0,0,1,50.18,16.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.18,45.38c-3.65-2.23-6.37-3.3-7.62-6.92H6.89V28.68h4.93A23.18,23.18,0,0,1,19.67,19V13.33l-2.5,2.5v2a26,26,0,0,0-7,8.38H6.82L4.39,28.61v8.78L8,41h2c1.5,2.76,3.87,4.15,6.36,5.61l.39.23v2.88l2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M56.63,31.85A16.54,16.54,0,0,0,55,24.71a6,6,0,0,0,1.19-1.53l-1.92-1.92A3.28,3.28,0,0,1,53,23.11a3.9,3.9,0,0,1-1.5.52,14.28,14.28,0,0,1,2.66,8.22c0,4.71-2.4,9-6.29,12.07v7.24l2.5-2.5V45.08A17.6,17.6,0,0,0,56.63,31.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.84,15.84a20.53,20.53,0,0,1,6.62-1.12c7.23,0,13.62,2.8,17.56,7.1a3.37,3.37,0,0,0,.66.06A2.6,2.6,0,0,0,52,21.56a1.76,1.76,0,0,0,.58-1.32A.84.84,0,0,0,52,19.5a3.06,3.06,0,0,1-1.88-2.36L48,15a5.31,5.31,0,0,0-.26.8,5.2,5.2,0,0,0-.1.78,28,28,0,0,0-15.17-4.35,23.05,23.05,0,0,0-5.46.67,8.93,8.93,0,0,0-3.93-3l-2,2A6.58,6.58,0,0,1,25.84,15.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.05,52.48V48.4a26.83,26.83,0,0,1-5.59.58,28.72,28.72,0,0,1-3.5-.22v3.72H19.48L22,55h9.08a.4.4,0,0,0,.4-.4V51.47h1a28.93,28.93,0,0,0,3.09-.16v3.26a.4.4,0,0,0,.4.4H44l2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M53,23.11a3.46,3.46,0,0,0,1.44-3,2.61,2.61,0,0,0-1.64-2.28c-.58-.27-.91-.73-.82-1.15s.83-.86,1.83-.86V14c-2.29,0-3.37,1.18-3.6,2.29A2.88,2.88,0,0,0,52,19.5a.84.84,0,0,1,.58.74A1.76,1.76,0,0,1,52,21.56a3.14,3.14,0,0,1-2,.26c-3.94-4.3-10.33-7.1-17.56-7.1a20.53,20.53,0,0,0-6.62,1.12,6.54,6.54,0,0,0-6.17-4V19a23.18,23.18,0,0,0-7.85,9.64H6.89v9.78h4.67c1.25,3.62,4,4.69,7.62,6.92v7.1H29V48.76a28.72,28.72,0,0,0,3.5.22,26.83,26.83,0,0,0,5.59-.58v4.08h9.79V43.92c3.89-3.1,6.29-7.36,6.29-12.07a14.28,14.28,0,0,0-2.66-8.22A3.9,3.9,0,0,0,53,23.11ZM18,29a2,2,0,1,1,2-2A2,2,0,0,1,18,29Zm16.5,9.66v1.68a.67.67,0,0,1-.67.65h-2a.65.65,0,0,1-.65-.65V38.89a7.65,7.65,0,0,1-1.81-.52,1,1,0,0,1-.6-1.16l.17-.65a1,1,0,0,1,.52-.65,1.05,1.05,0,0,1,.78,0,5.73,5.73,0,0,0,2.24.43c.34,0,1.46-.05,1.46-.85,0-.45-.14-.79-1.73-1.33s-3.4-1.29-3.4-3.53a3.61,3.61,0,0,1,2.42-3.38V25.68a.65.65,0,0,1,.18-.47.6.6,0,0,1,.47-.2h2a.65.65,0,0,1,.65.65v1.41A4.16,4.16,0,0,1,36,27.4a1,1,0,0,1,.6,1.17l-.13.67a1.12,1.12,0,0,1-.52.63.85.85,0,0,1-.76,0,5.31,5.31,0,0,0-1.77-.3c-.82,0-1.29.36-1.29.77s.51.73,2,1.29c2.22.79,3.16,1.86,3.16,3.65A4.26,4.26,0,0,1,34.5,38.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 18,
    cy: 27,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.08,31.63c-1.48-.56-2-.89-2-1.29s.47-.77,1.29-.77a5.31,5.31,0,0,1,1.77.3.85.85,0,0,0,.76,0,1.12,1.12,0,0,0,.52-.63l.13-.67A1,1,0,0,0,36,27.4a4.16,4.16,0,0,0-1.39-.33V25.66a.65.65,0,0,0-.65-.65h-2a.6.6,0,0,0-.47.2.65.65,0,0,0-.18.47v1.57a3.61,3.61,0,0,0-2.42,3.38c0,2.24,1.81,3,3.4,3.53S34,35,34,35.49c0,.8-1.12.85-1.46.85a5.73,5.73,0,0,1-2.24-.43,1.05,1.05,0,0,0-.78,0,1,1,0,0,0-.52.65l-.17.65a1,1,0,0,0,.6,1.16,7.65,7.65,0,0,0,1.81.52v1.45a.65.65,0,0,0,.65.65h2a.67.67,0,0,0,.67-.65V38.66a4.26,4.26,0,0,0,2.74-3.38C37.24,33.49,36.3,32.42,34.08,31.63Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMAhorro);
export default __webpack_public_path__ + "static/media/m_ahorro.bd07af3e66a4130fc12284c112687ab4.svg";
export { ForwardRef as ReactComponent };